var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skeleton",style:({ 'border-radius': _vm.borderRadius + 'px' })})
}
var staticRenderFns = []

export { render, staticRenderFns }